module.exports = __webpack_public_path__ + "static/media/linkedin-alt.34c68c57.png";